export const IS_DEFFERED_SUBSCRIPTION_ACTIVE = true
